module.exports = __webpack_public_path__ + "img/LcWaikiki.d96cf8fc.png";